import type { MembershipProduct } from "./SpaceType";

export function findConceptModule(
  products: MembershipProduct[]
): MembershipProduct | null {
  return products.find((p) => p.productKind === "concept") ?? null;
}

export function isConceptSubscribed(products: MembershipProduct[]): boolean {
  const mod = findConceptModule(products);
  return mod?.userSubscribed === true;
}
